export enum TabManageEnum {
  BASIC = "BASIC",
  QUESTIONS = "QUESTIONS",
  SCHEDULE = "SCHEDULE",
  ADVANCED = "ADVANCED"
}
